module.exports = __webpack_public_path__ + "media/icons/favourite-on-fa72b15b.png";